import React, { useState, useEffect } from "react";
import api from "../../../api/axios";
import toast from "react-hot-toast";
import { Plus, Trash2, Tag, Loader2, Search, Hash } from "lucide-react";

export default function GaleriTagListPage() {
  const [tags, setTags] = useState([]);
  const [newTag, setNewTag] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchTags = async () => {
    try {
      const res = await api.get("/galeritag");
      setTags(res.data || []);
    } catch { toast.error("Etiketler yüklenemedi"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchTags(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newTag.trim()) return toast.error("Etiket adı boş olamaz");
    setSaving(true);
    try {
      await api.post("/galeritag", JSON.stringify(newTag.trim()), {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Etiket eklendi");
      setNewTag("");
      fetchTags();
    } catch { toast.error("Etiket eklenemedi"); }
    finally { setSaving(false); }
  };

  const handleDelete = (id) => {
    if (!window.confirm("Bu etiketi silmek istediğinize emin misiniz?")) return;
    api.delete(`/galeritag/${id}`)
      .then(() => { toast.success("Etiket silindi"); fetchTags(); })
      .catch(() => toast.error("Silme başarısız"));
  };

  const filteredTags = tags.filter((tag) =>
    String(tag.tagName || "").toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="page-loading"><div className="loading-spinner" /><p>Yükleniyor...</p></div>;

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Galeri Etiketleri</h2>
          <p className="page-subtitle">{filteredTags.length} / {tags.length} etiket</p>
        </div>
      </div>

      <div className="content-card gallery-tags-card" style={{ maxWidth: 760 }}>
        <form onSubmit={handleAdd} className="inline-form">
          <input
            type="text"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
            className="form-input"
            placeholder="Yeni etiket adı (örn: Kurumsal, Ürün, Ekip)"
          />
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? <Loader2 size={18} className="spin" /> : <><Plus size={18} /> Ekle</>}
          </button>
        </form>

        <div className="search-box gallery-tag-search">
          <Search size={16} />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Etiket ara..."
          />
        </div>

        <div className="tag-list">
          {filteredTags.map((tag, index) => (
            <div key={tag.galeriTagId} className="tag-item">
              <div className="tag-info">
                <Tag size={16} />
                <span>{tag.tagName}</span>
              </div>
              <div className="gallery-tag-actions">
                <span className="gallery-tag-order"><Hash size={12} /> {index + 1}</span>
                <button onClick={() => handleDelete(tag.galeriTagId)} className="btn-icon delete small">
                  <Trash2 size={14} />
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredTags.length === 0 && (
          <div className="empty-state small">
            <p>{search ? "Aramaya uygun etiket bulunamadı" : "Henüz etiket eklenmemiş"}</p>
          </div>
        )}
      </div>
    </div>
  );
}
